import { toast } from "sonner";

export const copyToClipboard = (stringToCopy: string | undefined, infoMessage: string) => {
  if (!stringToCopy) toast.error("Failed to copy to clipboard");
  else {
    navigator.clipboard
      .writeText(stringToCopy)
      .then(() => toast.success(infoMessage))
      .catch(() => {
        toast.error("Failed to copy to clipboard");
      });
  }
};

export const generateUniqueId = () => {
  const s4 = () =>
    Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  // return id of format 'aaaaaaaa'-'aaaa'-'aaaa'-'aaaa'-'aaaaaaaaaaaa'
  return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
};

export const downloadString = (data: string, type: string, name: string) => {
  const blob = new Blob([data], { type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.click();
  URL.revokeObjectURL(url);
};
